import axios from '../../plugins/axiosPlugin'

const BASE_URL = 'lagerverwaltung/lager'
const BT_URL = 'bluetooth/receiver'

export default {
  state: {
    allStorages: [],
    allStoragesLoading: false,
    
    selectedPlanUrl: null,

    allReceivers: [],
    allreceiversLoading: false,

    allPositions: [],
    allPositionsLoading: false,
  },
  mutations: {
    setAllStorages(state, allStorages) {
      state.allStorages = allStorages
    },
    setAllStoragesLoading(state, allStoragesLoading) {
      state.allStoragesLoading = allStoragesLoading
    },
    setSelectedPlanUrl(state, selectedPlanUrl) {
      state.selectedPlanUrl = selectedPlanUrl
    },
    setAllReceivers(state, allReceivers) {
      state.allReceivers = allReceivers
    },
    setAllReceiversLoading(state, allReceiversLoading) {
      state.allReceiversLoading = allReceiversLoading
    },
    setAllPositions(state, allPositions) {
      state.allPositions = allPositions
    },
    setAllPositionsLoading(state, allPositionsLoading) {
      state.allPositionsLoading = allPositionsLoading
    }
  },
  actions: {
    getAllStorages(context, pagination) {
      context.commit('setAllStoragesLoading', true)
      let url = BASE_URL
      axios
        .get(url, pagination)
        .then((response) => context.commit('setAllStorages', response.data.data))
        .catch((e) => console.log(e))
        .finally(() => context.commit('setAllStoragesLoading', false))
    },
    getPositions(context, lager) {
      context.commit('setAllPositionsLoading', true)
      let url = '/bluetooth/tracker/lager/' + lager
      axios
        .get(url)
        .then((response) => context.commit('setAllPositions', response.data.data))
        .catch((e) => console.log(e))
        .finally(() => context.commit('setAllPositionsLoading', false))
    },
    deleteStoragePromise(context, storageID) {
      const url = BASE_URL + "/" + storageID
      return axios.delete(url)
    },
    registerStoragePromise(context, standort) {
      const url = BASE_URL
      return axios.put(url, standort)
    },
    editStoragePromise(context, storage) {
      return axios.post(BASE_URL + "/" + storage.ID, storage)
    },
    getImage(context, urlExtension) {
      urlExtension = urlExtension.replace(/^(\.\.\/)+/, ''); 
      let filename = urlExtension.split('/').pop();
      const url = 'uploads/' + filename
      axios.get(url , { responseType: 'blob' })
      .then(response => context.commit('setSelectedPlanUrl', URL.createObjectURL(response.data)))
      .catch(error => {
        console.error('Fehler beim Laden des Bildes:', error);
      });
    },
    getAllReceivers(context, storageID) {
      context.commit('setAllReceiversLoading', true)
      context.commit('setAllReceivers', [])
      let url = BT_URL + '/' + storageID
      axios
        .get(url)
        .then((response) => context.commit('setAllReceivers', response.data))
        .catch((e) => console.log(e))
        .finally(() => context.commit('setAllReceiversLoading', false))
    },
    registerReceiverPromise(context, selectedReceiver) {
      const url = BT_URL + '/' + selectedReceiver.lagerID
      return axios.put(url, selectedReceiver)
    },
  },

}
